import { createCompareFn } from 'utils/sort';

export const SCORE = 'score';
export const MOST_RECENT = 'mostRecent';
export const ALPHABETICAL = 'aToZ';

export const completedAssignments = {
  [ALPHABETICAL]: {
    get label() {
      return t('content.sort.alphabet_range');
    },
    sort: createCompareFn('title'),
  },
  [MOST_RECENT]: {
    get label() {
      return t('content.sort.most_recent');
    },
    sort: createCompareFn('progress.completedDate', 'desc'),
  },
};

export const completedJourneyAssignments = {
  [ALPHABETICAL]: {
    get label() {
      return t('content.sort.alphabet_range');
    },
    sort: createCompareFn('title'),
  },
  [MOST_RECENT]: {
    get label() {
      return t('content.sort.most_recent');
    },
    sort: createCompareFn('progress.completedAt', 'desc'),
  },
};
